/** @jsxImportSource @emotion/react */
import { SearchOutlined } from "@ant-design/icons";
import { css } from "@emotion/react";
import {
  Button,
  Input,
  InputNumber,
  message,
  Modal,
  Radio,
  Space,
  Table,
} from "antd";
import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { useFormatMessage } from "src/hooks";
import messageIds from "src/locales/messageIds";
import {
  AppServiceManage,
  UserService,
  UserServiceList,
} from "src/models/aiPlatform";
import { AiServiceClient } from "src/services/AIPlatformService";
import "./ServiceOperation.css";

const itemCss = css`
  display: flex;
  align-items: center;
  float: right;
  margin-left: 40px;
`;

const rowCss = css`
  color: rgba(0, 0, 0, 0.85);
  background-color: rgb(247, 249, 252);
  padding: 10px 13px;
  min-height: 35px;
  display: flex;
  align-items: center;
  width: 450px;
`;

export default React.memo(
  (props: {
    isEditShow?: boolean;
    editDetail: AppServiceManage;
    onEditCancel?: () => void;
    fetch: () => void;
  }) => {
    const { isEditShow, onEditCancel, editDetail, fetch } = props;
    const formatMessage = useFormatMessage();
    const [dataSource, setDataSource] = useState<UserService[]>([]);
    const [type, setType] = useState(0);
    const [maxCallLimited, setMaxCallLimited] = useState<number | undefined>(
      undefined
    );
    const [data, setData] = useState<UserServiceList[]>([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>([]);
    const [isEdit, setIsEdit] = useState(false);
    // const [appMasterSecret, setAppMasterSecret] = useState("");
    // const [appSecondSecret, setAppSecondSecret] = useState("");
    const [unSelectedData, setUnSelectedData] = useState<UserServiceList[]>([]);
    const [idandlimit, setIdandlimit] = useState<UserServiceList[]>([]);
    const [idandtype, setIdandtype] = useState<UserServiceList[]>([]);
    const [recordRow, setRecordRow] = useState({} as UserService);
    const [selectedRow, setSelectedRow] = useState<number[]>([]);
    const [nowSelectedData, setNowSelectedData] = useState<UserServiceList[]>(
      []
    );
    const [nowThdata, setNowThdata] = useState<UserServiceList[]>([]);
    const [nowMadata, setNowMadata] = useState<UserServiceList[]>([]);
    const [loading, setLoading] = useState(true);
    // const [searchText, setSearchText] = useState("");
    // const [searchedColumn, setSearchedColumn] = useState("");

    // useEffect(() => {
    //   if (isEditShow) {
    //     editDetail?.appMasterSecret &&
    //       setAppMasterSecret(editDetail?.appMasterSecret);
    //     editDetail?.appSecondSecret &&
    //       setAppSecondSecret(editDetail?.appSecondSecret);
    //   }
    // }, [editDetail?.appMasterSecret, editDetail?.appSecondSecret, isEditShow]);

    const list = useCallback(() => {
      AiServiceClient.getUserService(editDetail?.id).then((res) => {
        setDataSource(res.data.data);
        res?.data?.data
          ?.filter((res: UserService) => res.maxCallLimited !== null)
          ?.map((item: UserService) => selectedRow.push(item?.id));
        setSelectedRowKeys(selectedRow);
        //
        const nowData = [];
        const thdata = [];
        const madata = [];
        for (let i = 0; i < res.data.data.length; i++) {
          thdata.push({
            serviceId: res.data.data[i].id,
            type: res.data.data[i].type ?? 0,
          });
          setIdandtype(thdata);
          setNowThdata(thdata);
          //
          madata.push({
            serviceId: res.data.data[i].id,
            maxCallLimited: res.data.data[i].maxCallLimited,
          });
          setIdandlimit(madata);
          setNowMadata(madata);
          //
          if (
            res.data.data[i].type !== null &&
            res.data.data[i].maxCallLimited !== null
          )
            nowData.push({
              serviceId: res.data.data[i].id,
              type: res.data.data[i].type,
              maxCallLimited: res.data.data[i].maxCallLimited,
            });
          setData(nowData);
          setNowSelectedData(nowData);
        }
        setLoading(false);
      });
    }, [editDetail?.id, selectedRow]);

    useEffect(() => {
      if (isEditShow) {
        list();
      }
    }, [isEditShow, list]);

    const onModalCancel = useCallback(() => {
      onEditCancel && onEditCancel();
      setMaxCallLimited(undefined);
      setData([]);
      setType(0);
      setSelectedRow([]);
      setSelectedRowKeys([]);
      setDataSource([]);
      setIsEdit(false);
      setIdandtype([]);
      setIdandlimit([]);
    }, [onEditCancel]);

    const onCancel = useCallback(() => {
      setIsEdit(false);
      setData(nowSelectedData);
      setSelectedRowKeys(selectedRow);
      setUnSelectedData([]);
      setIdandtype(nowThdata);
      setIdandlimit(nowMadata);
      setType(0);
      setMaxCallLimited(undefined);
    }, [nowSelectedData, selectedRow, nowThdata, nowMadata]);

    const nameSearch = useCallback((selectedKeys, confirm, dataIndex) => {
      confirm();
      // setSearchText(selectedKeys[0]);
      // setSearchedColumn(dataIndex);
    }, []);

    const handleReset = useCallback((clearFilters) => {
      clearFilters();
      // setSearchText("");
    }, []);

    const columnsEdit = [
      {
        title: formatMessage(messageIds.aiManage.serviceManagement.name),
        dataIndex: "serviceName",
        width: "28%",
        sorter: (a: UserService, b: UserService) =>
          a.serviceName?.localeCompare(b.serviceName),
        filterDropdown: ({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
        }: any) => (
          <div
            css={css`
              padding: 8px;
            `}
          >
            <Input
              placeholder={formatMessage(messageIds.common.searchName)}
              value={selectedKeys[0]}
              onChange={(e) =>
                setSelectedKeys(e.target.value ? [e.target.value] : [])
              }
              onPressEnter={() =>
                nameSearch(selectedKeys, confirm, "serviceName")
              }
              css={css`
                display: block;
                margin-bottom: 8px;
              `}
            ></Input>
            <Space>
              <Button
                type="primary"
                onClick={() => nameSearch(selectedKeys, confirm, "serviceName")}
                icon={<SearchOutlined />}
                size="small"
                css={css`
                  width: 90px;
                `}
              >
                {formatMessage(messageIds.common.select)}
              </Button>
              <Button
                onClick={() => handleReset(clearFilters)}
                size="small"
                css={css`
                  width: 90px;
                `}
              >
                {formatMessage(messageIds.common.reset)}
              </Button>
            </Space>
          </div>
        ),
        filterIcon: (filtered: any) => (
          <SearchOutlined
            css={css`
              color: ${filtered ? "#1890ff" : undefined};
            `}
          ></SearchOutlined>
        ),
        onFilter: (value: any, record: any) =>
          record.serviceName && record.serviceName.includes(_.trim(value)),
        onFilterDropdownVisibleChange: (visible: boolean) => {
          if (visible) {
            setTimeout(() => nameSearch, 100);
          }
        },
      },
      {
        title: formatMessage(
          messageIds.aiManage.userServiceManagement.createService.type
        ),
        dataIndex: "type",
        width: "32%",
        render: (text: number, record: UserService) => (
          <Radio.Group
            defaultValue={record.type !== null ? record.type : type}
            onChange={(e) => {
              setType(e.target.value);
              const data = [];
              data.push({
                serviceId: record.id,
                type: e.target.value,
              });
              if (idandtype.length > 0) {
                const now = idandtype.filter(
                  (item) => item.serviceId !== record.id
                );
                setIdandtype([...now, ...data]);
              } else {
                setIdandtype(data);
              }
            }}
          >
            <Radio value={0}>
              {formatMessage(
                messageIds.aiManage.userServiceManagement.createService.trial
              )}
            </Radio>
            <Radio value={1}>
              {formatMessage(
                messageIds.aiManage.userServiceManagement.createService.formal
              )}
            </Radio>
          </Radio.Group>
        ),
      },
      {
        title: formatMessage(
          messageIds.aiManage.userServiceManagement.createService.maxCallLimited
        ),
        dataIndex: "maxCallLimited",
        width: "25%",
        render: (text: number, record: UserService) => (
          <InputNumber
            css={css`
              width: 100px;
            `}
            defaultValue={record.maxCallLimited}
            onChange={(e) => {
              setMaxCallLimited(e);
              const data = [];
              data.push({
                serviceId: record.id,
                maxCallLimited: e,
              });
              if (idandlimit.length > 0) {
                const now = idandlimit.filter(
                  (item) => item.serviceId !== record.id
                );
                setIdandlimit([...now, ...data]);
              } else {
                setIdandlimit(data);
              }
            }}
          ></InputNumber>
        ),
      },
      {
        title: formatMessage(
          messageIds.aiManage.userServiceManagement.createService.used
        ),
        dataIndex: "used",
        width: "20%",
      },
    ];

    const columnsRead = [
      {
        title: formatMessage(messageIds.aiManage.serviceManagement.name),
        dataIndex: "serviceName",
        width: "30%",
      },
      {
        title: formatMessage(
          messageIds.aiManage.userServiceManagement.createService.type
        ),
        dataIndex: "type",
        width: "23%",
        render: (text: number, record: UserService) =>
          record?.type === 0 || record?.type === null
            ? formatMessage(
                messageIds.aiManage.userServiceManagement.createService.trial
              )
            : formatMessage(
                messageIds.aiManage.userServiceManagement.createService.formal
              ),
      },
      {
        title: formatMessage(
          messageIds.aiManage.userServiceManagement.createService.maxCallLimited
        ),
        dataIndex: "maxCallLimited",
        width: "23%",
      },
      {
        title: formatMessage(
          messageIds.aiManage.userServiceManagement.createService.used
        ),
        dataIndex: "used",
        width: "23%",
      },
    ];

    const onSelectChange = useCallback((selectedRowKeys, selectedRow) => {
      setSelectedRowKeys(selectedRowKeys);
    }, []);

    useEffect(() => {
      const selectedData = [];
      if (recordRow.id || selectedRowKeys) {
        const firth = selectedRowKeys.filter((item) => item === recordRow.id);
        if (firth.length > 0) {
          if (
            data.length > 0 &&
            selectedRowKeys.length > 0 &&
            data.length === selectedRowKeys.length
          ) {
            if (recordRow.id !== selectedRowKeys[selectedRowKeys.length - 1]) {
              const oriType = data.filter(
                (item) => item.serviceId === recordRow.id
              )[0]?.type;
              const oriLimit = data.filter(
                (item) => item.serviceId === recordRow.id
              )[0]?.maxCallLimited;
              if (
                idandtype.filter((item) => item.serviceId === recordRow.id)[0]
                  ?.type !== oriType &&
                idandlimit.filter((item) => item.serviceId === recordRow.id)[0]
                  ?.maxCallLimited === oriLimit
              ) {
                selectedData.push({
                  serviceId: recordRow.id,
                  type: type,
                  maxCallLimited: oriLimit,
                });
              }
              if (
                idandtype.filter((item) => item.serviceId === recordRow.id)[0]
                  ?.type === oriType &&
                idandlimit.filter((item) => item.serviceId === recordRow.id)[0]
                  ?.maxCallLimited !== oriLimit
              ) {
                selectedData.push({
                  serviceId: recordRow.id,
                  type: oriType,
                  maxCallLimited: maxCallLimited,
                });
              }
              if (
                idandtype.filter((item) => item.serviceId === recordRow.id)[0]
                  ?.type !== oriType &&
                idandlimit.filter((item) => item.serviceId === recordRow.id)[0]
                  ?.maxCallLimited !== oriLimit
              ) {
                selectedData.push({
                  serviceId: recordRow.id,
                  type: type,
                  maxCallLimited: maxCallLimited,
                });
              }
              if (
                idandtype.filter((item) => item.serviceId === recordRow.id)[0]
                  ?.type === oriType &&
                idandlimit.filter((item) => item.serviceId === recordRow.id)[0]
                  ?.maxCallLimited === oriLimit
              ) {
                selectedData.push({
                  serviceId: recordRow.id,
                  type: oriType,
                  maxCallLimited: oriLimit,
                });
              }
              const nowSelect = data.filter(
                (item) => item.serviceId !== recordRow.id
              );
              setData([...nowSelect, ...selectedData]);
            } else {
              const ifData = data.filter(
                (item) => item.serviceId === recordRow.id
              );
              if (ifData.length > 0) {
                selectedData.push({
                  serviceId: recordRow.id,
                  type: idandtype.filter(
                    (item) => item.serviceId === recordRow.id
                  )[0]?.type,
                  maxCallLimited: idandlimit.filter(
                    (item) => item.serviceId === recordRow.id
                  )[0]?.maxCallLimited,
                });
                const thirdData = data.filter(
                  (item) => item.serviceId !== recordRow.id
                );
                setData([...thirdData, ...selectedData]);
              } else {
                setType(0);
                selectedData.push({
                  serviceId: recordRow.id,
                  type: type,
                  maxCallLimited: maxCallLimited,
                });
                setData([...data, ...selectedData]);
              }
            }
          } else {
            const ifData = data.filter(
              (item) => item.serviceId === recordRow.id
            );
            if (ifData.length > 0 && recordRow.id) {
              selectedData.push({
                serviceId: recordRow.id,
                type: idandtype.filter(
                  (item) => item.serviceId === recordRow.id
                )[0]?.type,
                maxCallLimited: idandlimit.filter(
                  (item) => item.serviceId === recordRow.id
                )[0]?.maxCallLimited,
              });
              const thirdData = data.filter(
                (item) => item.serviceId !== recordRow.id
              );
              setData([...thirdData, ...selectedData]);
            } else {
              setType(0);
              selectedData.push({
                serviceId: recordRow.id,
                type: type,
                maxCallLimited: maxCallLimited,
              });
              setData([...data, ...selectedData]);
            }
          }
        } else {
          const unselected = [];
          const ifData = unSelectedData.filter(
            (item) => item.serviceId === recordRow.id
          );
          if (ifData.length > 0) {
            unselected.push({
              serviceId: recordRow.id,
              type: idandtype.filter(
                (item) => item.serviceId === recordRow.id
              )[0]?.type,
              maxCallLimited: idandlimit.filter(
                (item) => item.serviceId === recordRow.id
              )[0]?.maxCallLimited,
            });
            const thirdData = unSelectedData.filter(
              (item) => item.serviceId !== recordRow.id
            );
            setUnSelectedData([...thirdData, ...unselected]);
          } else {
            unselected.push({
              serviceId: recordRow.id,
              type: idandtype.filter(
                (item) => item.serviceId === recordRow.id
              )[0]?.type,
              maxCallLimited: idandlimit.filter(
                (item) => item.serviceId === recordRow.id
              )[0]?.maxCallLimited,
            });
            setUnSelectedData([...unSelectedData, ...unselected]);
          }
        }
        if (unSelectedData.length > 0) {
          const unselectedData = unSelectedData.filter(
            (item) => item.serviceId !== undefined
          );
          if (
            data.length <= 0 &&
            dataSource.length === selectedRowKeys.length &&
            unselectedData.length > 0
          ) {
            setData(unselectedData);
            setUnSelectedData([]);
          } else if (
            data.length > 0 &&
            dataSource.length === selectedRowKeys.length &&
            unselectedData.length > 0
          ) {
            setData([...data, ...unselectedData]);
            setUnSelectedData([]);
          } else {
            for (let i = 0; i < selectedRowKeys.length; i++) {
              const ifOtherData = unSelectedData.filter(
                (item) =>
                  item.serviceId === selectedRowKeys[i] &&
                  item.serviceId !== undefined
              );
              const unselectedRowKeys = [];
              unSelectedData.map((item) =>
                unselectedRowKeys.push(item.serviceId)
              );
              if (ifOtherData.length > 0) {
                const unselected = unSelectedData.filter(
                  (unselected) => unselected.serviceId === selectedRowKeys[i]
                );
                const resData = data.filter(
                  (resdata) => resdata.serviceId !== selectedRowKeys[i]
                );
                setData([...resData, ...unselected]);
                setUnSelectedData(
                  unSelectedData.filter(
                    (item) => item.serviceId !== selectedRowKeys[i]
                  )
                );
              }
            }
          }
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type, maxCallLimited, selectedRowKeys, recordRow]);

    const rowSelection = {
      selectedRowKeys,
      onChange: onSelectChange,
    };

    const OnEdit = useCallback(async () => {
      const dataLength = data?.filter(
        (item) =>
          item.maxCallLimited !== null &&
          selectedRowKeys.indexOf(item.serviceId) !== -1
      ).length;
      const selectLength = selectedRowKeys.length;
      if (dataLength >= selectLength) {
        const createData = {
          userId: editDetail?.id,
          userServiceList: data.filter(
            (item) =>
              item.maxCallLimited !== null &&
              selectedRowKeys.indexOf(item.serviceId) !== -1
          ),
        };
        const limitedScale =
          createData.userServiceList.filter(
            (item) =>
              Number(item?.maxCallLimited) < 0 ||
              Number(item?.maxCallLimited) > 9999999
          ).length > 0;
        if (createData.userServiceList.length > 0) {
          if (limitedScale) {
            message.error(
              formatMessage(messageIds.aiManage.userServiceManagement.scale)
            );
          } else {
            AiServiceClient.updateData(createData).then((res) => {
              if (res.data.success) {
                message.success(
                  formatMessage(messageIds.common.editSuccessfully)
                );
                list();
                fetch();
              } else {
                message.error(
                  `${formatMessage(messageIds.common.editFailed)}, ${
                    res.data.message
                  }`
                );
              }
            });
            onCancel();
            onModalCancel();
          }
        } else {
          message.error(
            formatMessage(
              messageIds.aiManage.userServiceManagement.editService.tiptop
            )
          );
        }
      } else {
        message.error(
          formatMessage(
            messageIds.aiManage.userServiceManagement.editService.tip
          )
        );
      }
    }, [
      data,
      selectedRowKeys,
      editDetail?.id,
      formatMessage,
      onCancel,
      onModalCancel,
      list,
      fetch,
    ]);

    const onRowClick = useCallback((record, index) => {
      setRecordRow(record);
    }, []);

    // const onRefreshSecretKeyOne = useCallback(() => {
    //   AiServiceClient.refreshSecretKey(editDetail?.id, 1).then((res) => {
    //     setAppMasterSecret(res.data.data);
    //     fetch();
    //   });
    // }, [editDetail?.id, fetch]);

    // const onRefreshSecretKeyTwo = useCallback(() => {
    //   AiServiceClient.refreshSecretKey(editDetail?.id, 2).then((res) => {
    //     setAppSecondSecret(res.data.data);
    //     fetch();
    //   });
    // }, [editDetail?.id, fetch]);

    return (
      <div>
        <Modal
          title={formatMessage(messageIds.common.detail)}
          visible={isEditShow}
          footer={""}
          destroyOnClose
          onCancel={onModalCancel}
        >
          <div
            css={css`
              display: flex;
              align-items: center;
              margin-bottom: 40px;
            `}
          >
            <span
              css={css`
                width: 60px;
              `}
            >
              {formatMessage(messageIds.common.name)}
            </span>
            <div css={itemCss}>
              <div
                css={css`
                  ${rowCss}
                  word-wrap: break-word;
                  word-break: break-all;
                `}
              >
                {editDetail?.name}
              </div>
            </div>
          </div>
          {/* <div
            css={css`
              display: flex;
              align-items: center;
              margin-top: 40px;
            `}
          >
            <span
              css={css`
                width: 60px;
              `}
            >
              {formatMessage(messageIds.common.email)}
            </span>
            <div css={itemCss}>
              <div
                css={css`
                  ${rowCss}
                  word-wrap: break-word;
                  word-break: break-all;
                `}
              >
                {editDetail?.email}
              </div>
              {/* <div css={rowCss}>
                <Text ellipsis={{ tooltip: true }} copyable>
                  {appMasterSecret}
                </Text>
              </div> }
            </div>
          </div> */}
          {/* <div
            css={css`
              display: flex;
              align-items: center;
              margin-top: 40px;
              margin-bottom: 40px;
            `}
          >
            <span
              css={css`
                width: 60px;
              `}
            >
              {formatMessage(messageIds.common.phone)}
            </span>
            <div css={itemCss}>
              <div
                css={css`
                  ${rowCss}
                  word-wrap: break-word;
                  word-break: break-all;
                `}
              >
                {editDetail?.phone}
              </div>
              {/* <div css={rowCss}>
                <Text ellipsis={{ tooltip: true }} copyable>
                  {appSecondSecret}
                </Text>
              </div> }
            </div>
          </div> */}
          {isEdit ? (
            <>
              {/* <div
                css={css`
                  margin-top: 30px;
                `}
              >
                <Button
                  type="primary"
                  css={css`
                    margin-left: 110px;
                  `}
                  onClick={onRefreshSecretKeyOne}
                >
                  {formatMessage(
                    messageIds.aiManage.userServiceManagement.editService
                      .retrieveKeyOne
                  )}
                </Button>
                <Button
                  type="primary"
                  css={css`
                    margin-left: 60px;
                  `}
                  onClick={onRefreshSecretKeyTwo}
                >
                  {formatMessage(
                    messageIds.aiManage.userServiceManagement.editService
                      .retrieveKeyTwo
                  )}
                </Button>
              </div> */}
              <Table
                scroll={{ y: 400, x: "110%" }}
                css={css`
                  margin-top: 10px;
                `}
                rowKey={(record) => record?.id}
                columns={columnsEdit}
                dataSource={dataSource}
                pagination={false}
                rowSelection={rowSelection}
                onRow={(record, index) => ({
                  onClick: () => onRowClick(record, index),
                })}
                loading={loading}
              ></Table>
            </>
          ) : (
            <Table
              bordered
              scroll={{ y: 400, x: "100%" }}
              rowKey={(record) => record?.id}
              columns={columnsRead}
              dataSource={dataSource.filter(
                (dataSource) => dataSource.maxCallLimited !== null
              )}
              pagination={false}
              loading={loading}
            ></Table>
          )}
          {isEdit ? (
            <div
              css={css`
                text-align: right;
                margin-top: 20px;
              `}
            >
              <Button
                css={css`
                  margin-right: 20px;
                `}
                onClick={onCancel}
              >
                {formatMessage(messageIds.common.cancel)}
              </Button>
              <Button type="primary" onClick={OnEdit}>
                {formatMessage(messageIds.common.confirm)}
              </Button>
            </div>
          ) : (
            <div
              css={css`
                text-align: right;
                margin-top: 20px;
              `}
            >
              <Button type="primary" onClick={() => setIsEdit(true)}>
                {formatMessage(messageIds.common.edit)}
              </Button>
            </div>
          )}
        </Modal>
      </div>
    );
  }
);
